export const SpinImages = {

    spin3: require("../images/cardspin.gif"),
    spin4: require("../images/cardspin4.gif"),
    spin5: require("../images/cardspin3.gif"),

}